//
// Copyright (c) 2020 Astute Global, Inc.
//
// The controller to show whether other users are using the current topic.
//

define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "./topicUsageView",
  "./topicUsageModel",
], function (Marionette, Backbone, $, _, Messenger, TopicUsageView, TopicUsageModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicUsage";
    },
    show: function (topic) {
      const model = new Backbone.Model({
        message: "",
      });
      this.topic = topic;
      this.topicUsages = new TopicUsageModel.topicUsages();
      this.currentUser = Messenger.reqres.request("user");
      topic.onSynced(function () {
        if (!topic.isNew()) {
          const topicUsage = new TopicUsageModel.topicUsage();
          const intentId = topic.get("intentId");
          topicUsage.intentId = intentId;
          topicUsage.set("userId", this.currentUser.get("userId"));
          topicUsage.save();
          this.topicUsage = topicUsage;
          this.topicUsages.intentId = intentId;
          this.topicUsages.fetch();
        }
      }, this);
      this.model = model;
      this.view = new TopicUsageView.topicUsageView({ model: model });
      this.topicUsages.on("sync", this.onTopicUsagesSync, this);
      this.topicUsages.on("error", this.onTopicUsagesError, this);
      this.showRegion(this.view);
    },
    onClose: function () {
      if (this.topicUsage) {
        this.topicUsage.destroy();
      }
      if (this.usageTimeout) {
        window.clearTimeout(this.usageTimeout);
        this.usageTimeout = null;
      }
    },
    onTopicUsagesError: function () {
      this.pollForTopicUsages();
    },
    onTopicUsagesSync: function () {
      this.updateUsageMessage();
      this.pollForTopicUsages();
    },
    pollForTopicUsages: function () {
      const me = this;
      me.usageTimeout = window.setTimeout(function () {
        me.topicUsages.fetch();
      }, 20000);
    },
    updateUsageMessage: function () {
      const currentUserId = this.currentUser.get("userId");
      const otherUsers = this.topicUsages.filter(function (topicUsage) {
        return topicUsage.get("userId") != currentUserId;
      });
      let message = "";
      if (otherUsers && otherUsers.length > 0) {
        const userLogins = _.map(otherUsers, function (topicUsage) {
          return topicUsage.get("userLoginId");
        }).join(", ");
        message = $.t("topic.usage.message", { users: userLogins, count: otherUsers.length });
      }
      if (message != this.model.get("message")) {
        this.model.set("message", message);
        this.view.render();
      }
    },
  });
});
